import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import StatusTag from "@/components/feature/StatusTag";
import {
  allTopics,
  formatHeat,
  formatShortDate,
  getCategoryLabel,
  heatPercent,
  sortByHeat,
} from "@/lib/site";
import { siteFeatures } from "@/mocks/siteStats";

export default function HotRanking() {
  const ranked = sortByHeat(allTopics).slice(0, 6);

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="Hot List"
          title="今日热榜 · 讨论规模排序"
          description="热度值综合公开渠道的讨论数量、跨平台出现频率与持续时长折算，仅用于排序参考，不代表事件的重要程度。"
          actionLabel="查看全部档案"
          actionTo="/topics"
        />

        <div className="mt-8 grid gap-6 lg:grid-cols-[1.55fr_1fr]">
          <ol className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {ranked.map((topic, index) => {
              const percent = heatPercent(topic.heat);
              return (
                <li
                  key={topic.id}
                  className="border-b border-background-200 last:border-b-0"
                >
                  <article className="flex items-start gap-4 p-4 transition-colors hover:bg-background-100 md:p-5">
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                        index === 0
                          ? "bg-primary-500 text-background-50"
                          : index < 3
                            ? "bg-primary-100 text-primary-700"
                            : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-[11px] font-medium text-secondary-700">
                          {getCategoryLabel(topic.categoryId)}
                        </span>
                        <StatusTag label={topic.status} tone={topic.statusTone} />
                      </div>
                      <h3 className="mt-2 font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                        <Link to={`/topic/${topic.id}`} className="hover:text-primary-700">
                          {topic.title}
                        </Link>
                      </h3>
                      <div className="mt-3 flex items-center gap-3">
                        <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                          <span
                            className="block h-full rounded-full bg-primary-500"
                            style={{ width: `${percent}%` }}
                            aria-hidden="true"
                          />
                        </span>
                        <span className="shrink-0 text-xs font-medium text-foreground-600">
                          {formatHeat(topic.heat)}
                        </span>
                      </div>
                    </div>
                    <span className="hidden shrink-0 pt-1 text-[11px] text-foreground-500 md:block">
                      {formatShortDate(topic.updatedAt)}
                    </span>
                  </article>
                </li>
              );
            })}
          </ol>

          <aside className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              这里怎么追踪一件事
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              每份档案都遵循同一套记录方式，方便你在不同事件之间横向对照。
            </p>
            <ul className="mt-5 space-y-5">
              {siteFeatures.map((feature) => (
                <li key={feature.title} className="flex gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-secondary-200 bg-secondary-50 text-secondary-700">
                    <i className={`${feature.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <div>
                    <h4 className="font-heading text-sm font-semibold text-foreground-950">
                      {feature.title}
                    </h4>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                      {feature.desc}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}